import React from 'react';
const AtdwContext = React.createContext(null);
export { AtdwContext };